import { render, staticRenderFns } from "./leftNav.vue?vue&type=template&id=34fb65de&scoped=true"
import script from "./leftNav.vue?vue&type=script&lang=js"
export * from "./leftNav.vue?vue&type=script&lang=js"
import style0 from "./leftNav.vue?vue&type=style&index=0&id=34fb65de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb65de",
  null
  
)

export default component.exports